module.exports = __webpack_public_path__ + "static/media/AwsDoc8.d8dd657b.png";